// // Build a public offer URL the agent can send to players.
// // If `cardIds` empty => include all agent's active cards by default.
// export function buildOfferUrl({ origin = window.location.origin, agentUid, cardIds = [] }) {
//     const q = new URLSearchParams();
//     q.set("agent", agentUid);
//     if (cardIds.length) q.set("cards", cardIds.join(","));
//     // you can change route if you prefer
//     return `${origin}/lottery/offer?${q.toString()}`;
// }

// Build a public offer URL an agent can send to players.
// If cardIds is empty, the landing page will show all of the agent's active cards.
export function buildOfferUrl({ origin = window.location.origin, agentUid, cardIds = [] }) {
    const q = new URLSearchParams();
    q.set("agent", agentUid);
    if (cardIds.length) q.set("cards", cardIds.join(","));
    return `${origin}/lottery/offer?${q.toString()}`;
}
